import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { useAtomValue } from "jotai";
import { languageAtom } from "@/state/language";

type Translation = {
  t: (id?: string, values?: Record<string, string | number>) => string;
  tNode: (id?: string, values?: Record<string, string | number | ReactNode>) => string | ReactNode;
  language: string;
  locale: string;
};

export const useTranslation = (): Translation => {
  const intl = useIntl();
  const language = useAtomValue(languageAtom);
  const locale = language === "en" ? "en-US" : "nl-NL";

  // Overloaded function signatures for better type safety
  function t(id?: string, values?: Record<string, string | number>): string {
    if (!id) return "";

    try {
      return intl.formatMessage({ id }, values);
    } catch (error) {
      // Return the key itself as fallback when translation is missing
      console.warn(`Translation missing for key: ${id}`);
      return id;
    }
  }

  function tNode(
    id?: string,
    values?: Record<string, string | number | ReactNode>,
  ): string | ReactNode {
    if (!id) return "";

    try {
      return intl.formatMessage({ id }, values);
    } catch (error) {
      // Return the key itself as fallback when translation is missing
      console.warn(`Translation missing for key: ${id}`);
      return id;
    }
  }

  return { t, tNode, language, locale };
};
